import React from 'react';
import qs from 'qs';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { doc, onSnapshot, setDoc, deleteDoc } from 'firebase/firestore';
import { InstantSearch, InfiniteHits, SearchBox, Configure } from 'react-instantsearch';
import Cookies from 'js-cookie';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import MsgNetLoading from '../components/MsgNetLoading';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import IconFavoriteBorder from '../icons/IconFavoriteBorder';
import config from '../config';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';
import { FirebaseContext } from '../index';

function Participante({ hit, favoritos, onClickFavorito }) {
  const favorito = favoritos.indexOf(hit.dorsal) >= 0;

  return (
    <div className="list-none mb-3">
      <div className="flex items-center gap-3 py-3 bg-slate-900/50 hover:bg-slate-900/70 transition rounded-lg">
        {/* Botón favorito */}
        <button
          onClick={() => onClickFavorito(hit.dorsal)}
          className={[
            'flex-shrink-0 w-10 h-10 rounded-lg grid place-items-center transition-all',
            favorito
              ? 'bg-red-500 hover:bg-red-600'
              : 'bg-slate-800 hover:bg-slate-700 border border-slate-700'
          ].join(' ')}
          aria-label={favorito ? 'Quitar de favoritos' : 'Añadir a favoritos'}
        >
          <IconFavoriteBorder fill={favorito ? '#ffffff' : '#94a3b8'} />
        </button>

        {/* Contenido del participante */}
        <Link
          to={`/competicion/${hit.competicion_id}/dorsal/${hit.dorsal}`}
          className="flex-1 min-w-0"
        >
          <div className="truncate text-white font-medium font-montserrat text-base">
            {hit.nombre} {hit.apellidos}
          </div>
          <div className="mt-1 text-sm text-slate-400 font-montserrat">
            Dorsal <strong className="text-slate-200">{hit.dorsal}</strong>
            {hit.club && <span> - {hit.club}</span>}
            {hit.localidad && <span> - {hit.localidad}</span>}
          </div>
        </Link>

        {/* Indicador visual de link */}
        <div className="flex-shrink-0 text-slate-500">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Search(props) {
  return (
    <div className="w-full">
      <div className="mx-auto max-w-5xl px-4 md:px-40">
        {/* Search Box */}
        <div className="mb-6">
          <SearchBox
            placeholder="Busca por nombre, apellidos, dorsal, club..."
            classNames={{
              root: 'w-full',
              form: 'relative',
              input: 'w-full px-4 py-3 pr-12 bg-slate-900 border border-slate-700 rounded-lg text-white placeholder-slate-500 placeholder:text-sm font-montserrat focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent',
              submit: 'absolute right-3 top-1/2 -translate-y-1/2',
              submitIcon: 'w-5 h-5 text-slate-400',
              reset: 'absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-lg bg-slate-800 hover:bg-slate-700 border border-slate-700 grid place-items-center transition-colors cursor-pointer',
              resetIcon: 'w-4 h-4 text-slate-400',
              loadingIndicator: 'absolute right-3 top-1/2 -translate-y-1/2',
              loadingIcon: 'w-5 h-5 text-slate-400'
            }}
          />
        </div>

        {/* Results */}
        <InfiniteHits
          showPrevious={false}
          translations={{
            showMoreButtonText: '',
            showPreviousButtonText: ''
          }}
          classNames={{
            root: 'w-full',
            list: 'space-y-0',
            item: 'list-none'
          }}
          hitComponent={(hitProps) => {
            return (
              <Participante
                hit={hitProps.hit}
                favoritos={props.favoritos}
                onClickFavorito={props.onClickFavorito}
              />
            );
          }}
        />
      </div>
    </div>
  );
}

const urlToSearchState = (location) => {
  const d = qs.parse(location.search, { ignoreQueryPrefix: true });
  if (d.query) {
    return { query: d.query };
  } else {
    return { query: '' };
  }
};

class FavoritoSearchScreenClass extends React.Component {
  constructor(opts) {
    super(opts);
    this.state = {
      evento: null,
      competicion: null,
      favoritos: [],
      searchState: urlToSearchState(this.props.location),
      showSharePanel: false
    };
    this.debouncedSetState = null;
    this.unlisten = {};
  }

  toogleSharePanel() {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }));
  }

  componentDidMount() {
    const { db, params } = this.props;
    const competicionId = parseInt(params.competicionId, 10);

    // Competición
    const competicionRef = doc(db, 'competicion', competicionId.toString());
    this.unlisten.competicion = onSnapshot(competicionRef, (snapshot) => {
      let competicion = snapshot.exists() ? snapshot.data() : null;
      if (competicion) {
        competicion.id = snapshot.id;
      }
      this.setState({ competicion });
    });

    // Cargar favoritos de cookies
    const favoritosCookie = Cookies.get('favoritos-' + competicionId);
    if (favoritosCookie) {
      try {
        const favoritos = JSON.parse(favoritosCookie);
        this.setState({ favoritos: favoritos.map((o) => parseInt(o, 10) || null) });
      } catch (e) {
        console.error('Error parsing favoritos cookie:', e);
      }
    }
  }

  // UNSAFE_componentWillUpdate(nextProps, nextState) {
  //   const { db } = this.props;

  //   if (this.state.competicion !== nextState.competicion) {
  //     if (nextState.competicion) {
  //       const eventoId = nextState.competicion.evento_id;

  //       if (eventoId) {
  //         const eventoRef = doc(db, 'evento', String(eventoId));
  //         this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
  //           let evento = snapshot.exists() ? snapshot.data() : null;
  //           if (evento) {
  //             evento.id = snapshot.id;
  //           }
  //           this.setState({ evento });
  //         });
  //       }
  //     }
  //   }
  // }

  // UNSAFE_componentWillReceiveProps(props) {
  //   if (props.location !== this.props.location) {
  //     this.setState({ searchState: urlToSearchState(props.location) });
  //   }
  // }
  componentDidUpdate(prevProps, prevState) {
    const { db } = this.props;

    // Cargar evento cuando se carga la competición
    if (prevState.competicion !== this.state.competicion) {
      if (this.state.competicion) {
        const eventoId = this.state.competicion.evento_id;

        if (eventoId) {
          const eventoRef = doc(db, 'evento', String(eventoId));
          this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
            let evento = snapshot.exists() ? snapshot.data() : null;
            if (evento) {
              evento.id = snapshot.id;
            }
            this.setState({ evento });
          });
        }
      }
    }

    // Actualizar búsqueda cuando cambia la URL
    if (prevProps.location !== this.props.location) {
      this.setState({ searchState: urlToSearchState(this.props.location) });
    }
  }

  componentWillUnmount() {
    if (this.unlisten.competicion) {
      this.unlisten.competicion();
    }
    if (this.unlisten.evento) {
      this.unlisten.evento();
    }
  }

  onClickBack() {
    this.props.navigate(`/${this.state.competicion.evento_id}`);
  }

  async onClickFavorito(dorsal) {
    const { db, params } = this.props;
    const competicionId = parseInt(params.competicionId, 10);

    let favoritos = [...this.state.favoritos];
    let idx = favoritos.indexOf(dorsal);

    if (idx >= 0) {
      // Eliminar favorito
      favoritos.splice(idx, 1);
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN;
        await deleteDoc(doc(db, 'fcm', fstKey));
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoDel', favoritos.length);
      }
    } else {
      // Añadir favorito
      favoritos.push(dorsal);
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN;
        await setDoc(doc(db, 'fcm', fstKey), {
          competicion_id: competicionId,
          dorsal,
          token: window.FCM_TOKEN
        });
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoAdd', favoritos.length);
      }
    }

    this.setState({ favoritos });

    // Guardar en cookie (30 días)
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    Cookies.set('favoritos-' + competicionId, JSON.stringify(favoritos), {
      path: '/',
      expires: 30
    });
  }

  onSearchStateChange(searchState) {
    this.setState({ searchState });
  }

  render() {
    const evento = this.state.evento;
    const competicion = this.state.competicion;

    if (this.state.competicion) {
      return (
        <div>
          <TopHeaderMenu
            onClickBack={this.onClickBack.bind(this)}
            onClickShare={this.toogleSharePanel.bind(this)}
            competicion={this.state.competicion}
            evento={this.state.evento}
          />
          <CompeticionHeaderMenu
            competicion={this.state.competicion}
            selected={4}
            evento={this.state.evento}
          />
          <div className="pt-28"> 

            {/* Mensaje informativo */}
            <div className="flex justify-center mb-3">
              <div className="w-fit rounded-lg px-4 py-2 text-sm font-light tracking-wide text-center ring-1 font-montserrat ring-slate-700 text-slate-300 mx-4">
                Busca y añade atletas a tu lista de favoritos para seguirlos en tiempo real
              </div>
            </div>

            {this.state.competicion.visible && (
              <InstantSearch
                searchClient={algoliasearch(
                  config.ALGOLIA_APP_ID,
                  config.ALGOLIA_SEARCH_KEY
                )}
                indexName={config.ALGOLIA_INDEX_NAME}
                initialUiState={{
                  [config.ALGOLIA_INDEX_NAME]: this.state.searchState
                }}
                onStateChange={({ uiState }) => {
                  this.onSearchStateChange(uiState[config.ALGOLIA_INDEX_NAME] || {});
                }}
              >
                <Configure
                  filters={`competicion_id = ${this.props.params.competicionId}`}
                />
                <Search
                  favoritos={this.state.favoritos}
                  onClickFavorito={this.onClickFavorito.bind(this)}
                />
              </InstantSearch>
            )}
          </div>

          {this.state.showSharePanel && (
            <SharePanel
              close={this.toogleSharePanel.bind(this)}
              url={`/competicion/${competicion.id}/favoritos`}
              title={`Buscar favoritos en la prueba ${competicion.nombre} en ${evento.nombre}`}
            />
          )}
        </div>
      );
    } else {
      return <MsgNetLoading />;
    }
  }
}

// Wrapper funcional
function FavoritoSearchScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const { db } = React.useContext(FirebaseContext);

  return (
    <FavoritoSearchScreenClass
      navigate={navigate}
      params={params}
      location={location}
      db={db}
    />
  );
}

export default FavoritoSearchScreen;